module.exports = __webpack_public_path__ + "static/theme-editor-show-promo-text-on-top-left-header-2c900cf7736ee07453a63ca7e0714a5f.png";